import AgOrderPay from '@/pages/handle/agOrderPay'
import OrderDetailly from '@/pages/handle/agOrderPay/orderDetail'

export default [
  {
    path: '/agOrderPay',
    name: 'AgOrderPay',
    component: AgOrderPay,
    meta: { name: '订单付款' }
  },
  {
    path: '/agOrderPay/orderDetailly/:orderId',
    name: 'OrderDetailly',
    component: OrderDetailly,
    props: true,
    meta: { name: ['订单付款', '订单详情'] }
  }
]



// WEBPACK FOOTER //
// ./src/router/handle/agOrderPay.js